import { cloneDeep } from 'lodash';
import * as defaultConfig from '@/config/default-config.json';
import { utils, writeFile } from 'xlsx';

export function cleanObj(dirtyObj) {
  const obj = cloneDeep(dirtyObj);
  Object.keys(obj).map((key) => {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
    return key;
  });
  return obj;
}

export const isNumber = (value) => (typeof value === 'number' || value instanceof Number)
  && !Number.isNaN(value * 1);

export const noop = () => undefined;

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function isInternalProcessRoute(route) {
  return defaultConfig.global.internalProcessRouteNames.some((routeName) => routeName === route.name);
}

export function exportExcel(jsonData, filename) {
  // Export excel file from json data
  const workSheet = utils.json_to_sheet(jsonData);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, workSheet, filename);
  writeFile(workBook, `${filename}.xlsx`);
}
